module.exports = __webpack_public_path__ + "static/img/皮带跑偏识别.d1e1e1d9.png";